import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  path?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1 text-xs text-foreground-500 md:text-sm">
      <Link to="/" className="transition-colors hover:text-primary-700">首页</Link>
      {items.map((item) => (
        <span key={item.label} className="flex items-center gap-1">
          <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center"></i>
          {item.path ? (
            <Link to={item.path} className="transition-colors hover:text-primary-700">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-700">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}